import FieldNames from "../../../aiim/datasets/FieldNames";
import OfficePlan from "../OfficePlan";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as sourceUtil from "../sourceUtil";
import * as transaction from "./transaction";
import {addAttributeEdit, fetchGlobalIds} from "./transactionUtil";

/*
  transactions

    addArea
    deleteArea
    renameArea
    unassignArea

*/

function afterAddArea(results,undoTransaction,method) {
  // fix the undo (i.e. the delete) following an add
  const areasTable = OfficePlan.getActive().areasTable;
  const areasLayerId = areasTable.table.layerId;
  const requestInfo = undoTransaction.requestInfo;
  const query = requestInfo.requestOptions.query;
  results.forEach(layerResult => {
    if (layerResult.id === areasLayerId) {
      if (layerResult.addResults && layerResult.addResults.length === 1) {
        const newKey = layerResult.addResults[0].globalId;
        //console.log("******************************* newKey",newKey)

        let edits = JSON.parse(query.edits);
        if (Array.isArray(edits)) {
          let found = false;
          edits.forEach(layerEdit => {
            if (layerEdit.id === areasLayerId) {
              if (layerEdit.deletes && layerEdit.deletes.length === 1) {
                console.log("found deletes",layerEdit)
                layerEdit.deletes = [newKey];
                found = true;
              }
            }
          });
          if (found) {
            //console.log("new edits",edits)
            query.edits = JSON.stringify(edits);
          }
        }
      }
    }
  });
}

export function prepare(task) {
  const promise = new Promise((resolve,reject) => {

    const transactionInfo = transaction.makeTransactionInfo();
    const peopleSource = sourceUtil.getPeopleSource();
    const unitsSource = sourceUtil.getUnitsSource();
    const areaItem = task.areaItem;
    const areaType = task.areaType;
    const areasTable = OfficePlan.getActive().areasTable;
    const areaId = areaItem && aiimUtil.getAttributeValue(
      areaItem.attributes,FieldNames.AREA_ID);
    const areaIds = [areaId];

    const makePeopleEdits = (keys) => {
      let updates = [], undos = [];
      const layer = peopleSource.layer2D;

      if (Array.isArray(keys)) {
        const fields = layer.fields;
        const keyField = layer.globalIdField;
        keys.forEach(key => {
          const update = {attributes: {}};
          update.attributes[keyField] = key;
          addAttributeEdit(fields,update.attributes,FieldNames.PEOPLE_AREA_ID,null);
          updates.push(update);
          const undo = {attributes: {}};
          undo.attributes[keyField] = key;
          addAttributeEdit(fields,undo.attributes,FieldNames.PEOPLE_AREA_ID,areaId);
          undos.push(undo);
        });
      }

      if (updates.length > 0) {
        transactionInfo.peopleEdits = {updates: updates};
        transactionInfo.undo.peopleEdits = {updates: undos};
        transactionInfo.edits.push({
          id: layer.layerId,
          updates: updates
        });
        transactionInfo.undo.edits.push({
          id: layer.layerId,
          updates: undos
        });
      }
    };

    const makeUnitEdits = (keys) => {
      const updates = [], undos = [];
      const layer = unitsSource.layer2D;

      if (Array.isArray(keys)) {
        const fields = layer.fields;
        const keyField = layer.globalIdField;
        const none = OfficePlan.SpaceAssignmentTypes.none;
        keys.forEach(key => {
          const update = {attributes: {}};
          update.attributes[keyField] = key;
          addAttributeEdit(fields,update.attributes,FieldNames.UNITS_AREA_ID,null);
          addAttributeEdit(fields,update.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,none);
          addAttributeEdit(fields,update.attributes,FieldNames.UTILIZATION,0);
          updates.push(update);
          const undo = {attributes: {}};
          undo.attributes[keyField] = key;
          addAttributeEdit(fields,undo.attributes,FieldNames.UNITS_AREA_ID,areaId);
          addAttributeEdit(fields,undo.attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,areaType);
          addAttributeEdit(fields,undo.attributes,FieldNames.UTILIZATION,0);
          undos.push(undo);
        });
      }

      if (updates.length > 0) {
        transactionInfo.unitEdits = {updates: updates};
        transactionInfo.undo.unitEdits = {updates: undos};
        transactionInfo.edits.push({
          id: layer.layerId,
          updates: updates
        });
        transactionInfo.undo.edits.push({
          id: layer.layerId,
          updates: undos
        });
      }
    };

    const makeAreasTableEdits = () => {
      const table = areasTable.table;
      const fields = table.fields;
      const keyField = table.globalIdField;
      //const keyField = table.objectIdField;

      if (task.addArea) {
        const edit = {attributes: {}};
        addAttributeEdit(fields,edit.attributes,FieldNames.AREA_ID,task.areaId);
        addAttributeEdit(fields,edit.attributes,FieldNames.AREA_NAME,task.areaName);
        addAttributeEdit(fields,edit.attributes,FieldNames.AREA_TYPE,task.areaType);

        transactionInfo.areasTableEdits = {adds: [edit]};
        transactionInfo.undo.areasTableEdits = {deletes: ["?"]};
        transactionInfo.edits.push({
          id: table.layerId,
          adds: [edit]
        });
        transactionInfo.undo.edits.push({
          id: table.layerId,
          deletes: ["?"] // needs to be populated following add
        });
        transactionInfo.useGlobalIds = false;
        transactionInfo.afterApplyEdits = afterAddArea;
      }

      if (task.deleteArea) {
        const key = areaItem.attributes[keyField];;
        const undo = {attributes: Object.assign({},areaItem.attributes)};

        transactionInfo.areasTableEdits = {deletes: [key]}
        transactionInfo.undo.areasTableEdits = {adds: [undo]};
        transactionInfo.edits.push({
          id: table.layerId,
          deletes: [key]
        });
        transactionInfo.undo.edits.push({
          id: table.layerId,
          adds: [undo]
        });
      }

      if (task.renameArea) {
        const name = task.areaName;
        const prevName = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_NAME);
        const key = areaItem.attributes[keyField];
        const update = {attributes: {}};
        update.attributes[keyField] = key;
        addAttributeEdit(fields,update.attributes,FieldNames.AREA_NAME,name);
        const undo = {attributes: {}};
        undo.attributes[keyField] = key;
        addAttributeEdit(fields,undo.attributes,FieldNames.AREA_NAME,prevName);

        transactionInfo.areasTableEdits = {updates: [update]}
        transactionInfo.undo.areasTableEdits = {updates: [undo]}
        transactionInfo.edits.push({
          id: table.layerId,
          updates: [update]
        });
        transactionInfo.undo.edits.push({
          id: table.layerId,
          updates: [undo]
        });
      }
    };

    Promise.resolve().then(() => {
      if (task.unassignArea) {
        return fetchGlobalIds(peopleSource,areaIds,areaType).then(keys => {
          makePeopleEdits(keys);
        });
      }
    }).then(() => {
      if (task.unassignArea) {
        return fetchGlobalIds(unitsSource,areaIds,areaType).then(keys => {
          makeUnitEdits(keys);
        });
      }
    }).then(() => {
      makeAreasTableEdits();
    }).then(() => {
      resolve(transactionInfo);
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise;
}
